// Timeout on the Readwise side is 30 seconds.
// We set our timeout twice bigger to guarantee not to abort requests from our side.
export const TIMEOUT = 60 * 1000
export const CHUNK_SIZE = 50
